import { cva } from 'class-variance-authority';

export const buttonGroupVariants = cva(
  'eye:flex eye:w-fit eye:items-stretch eye:has-[>[data-slot=button-group]]:gap-2xs eye:[&>*]:relative eye:[&>*]:hover:z-10 eye:[&>*]:focus-visible:z-20 eye:[&>*]:active:z-20 eye:has-[select[aria-hidden=true]:last-child]:[&>[data-slot=select-trigger]:last-of-type]:rounded-r-md eye:[&>[data-slot=select-trigger]:not([class*=w-])]:w-fit eye:[&>input]:flex-1',
  {
    variants: {
      orientation: {
        horizontal:
          'eye:[&>*:not(:first-child)]:border-l-0 eye:[&>[data-slot=button-group-text]]:!rounded-none eye:[&>[data-slot=button-group-text]:first-child]:!rounded-l-md eye:[&>[data-slot=button-group-text]:last-child]:!rounded-r-md eye:[&>[data-slot=button]]:!rounded-none eye:[&>[data-slot=button]:first-child]:!rounded-l-md eye:[&>[data-slot=button]:last-child]:!rounded-r-md',
        vertical:
          'eye:flex-col eye:[&>*:not(:first-child)]:border-t-0 eye:[&>[data-slot=button-group-text]]:!rounded-none eye:[&>[data-slot=button-group-text]:first-child]:!rounded-t-md eye:[&>[data-slot=button-group-text]:last-child]:!rounded-b-md eye:[&>[data-slot=button]]:!rounded-none eye:[&>[data-slot=button]:first-child]:!rounded-t-md eye:[&>[data-slot=button]:last-child]:!rounded-b-md',
      },
    },
    defaultVariants: {
      orientation: 'horizontal',
    },
  },
);

export const buttonGroupTextVariants = cva(
  'eye:flex eye:items-center eye:gap-2xs eye:rounded-none eye:border eye:font-medium eye:[&_svg]:pointer-events-none eye:[&_svg:not([class*=size-])]:size-[20px]',
  {
    variants: {
      size: {
        default: 'eye:h-[44px] eye:px-20',
        sm: 'eye:h-[35px] eye:px-16',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
);
